import { http } from 'src/utils/http.util'
import { TMedicalStaffMember } from '../types/medical-staff-member'

export const MedicalStaffMemberService = {
  getMedicalStaffMemberList: async (projectId: number): Promise<Array<TMedicalStaffMember>> => {
    return http.get(`projects/${projectId}/medical-staff-members`).then((res) => res.data)
  },

  updateMedicalStaffMember: async (
    projectId: number,
    dataId: number,
    data: Partial<TMedicalStaffMember>,
  ): Promise<TMedicalStaffMember> => {
    return http.put(`projects/${projectId}/medical-staff-members/${dataId}`, data).then((res) => res.data)
  },

  createMedicalStaffMember: async (
    projectId: number,
    data: TMedicalStaffMember,
  ): Promise<TMedicalStaffMember> => {
    return http.post(`projects/${projectId}/medical-staff-members`, data).then((res) => res.data)
  },
}
